export interface AuditLog {
  version: number
  type: string
  data: AuditLogData
  externalData?: {
    name?: string
    value?: unknown
  }
  user: {
    id: string
    name: string
  } | null
  createdAt: string
}

interface AuditLogNameDto {
  Id: string | null
  Name: string | null
  id: string | null
  name: string | null
}

export type AuditLogDataCheck = string | AuditLogNameDto | Record<string, unknown>

export const isAuditLogNameDto = (data: AuditLogDataCheck): data is AuditLogNameDto => {
  return isAuditLogNameDtoId(data) && isAuditLogNameDtoName(data)
}

export const isAuditLogNameDtoId = (data: AuditLogDataCheck): boolean => {
  if (data === undefined || data === null) {
    return false
  }

  return (
    Object.prototype.hasOwnProperty.call(data, 'id') ||
    Object.prototype.hasOwnProperty.call(data, 'Id')
  )
}

export const isAuditLogNameDtoName = (data: AuditLogDataCheck): boolean => {
  if (data === undefined || data === null) {
    return false
  }

  return (
    Object.prototype.hasOwnProperty.call(data, 'name') ||
    Object.prototype.hasOwnProperty.call(data, 'Name')
  )
}

export type AuditLogData =
  | {
      [key: string]: string | Record<string, unknown>
    }
  | {
      [key: string]: AuditLogNameDto
    }
  | {
      Id: string
      [key: string]: string
    }
  | {
      Id: AuditLogNameDto
      [key: string]: string | AuditLogNameDto
    }
